import { useContext } from 'react';
import { SidebarContext } from '../../data/context/SidebarContext';

/**
 * UseSidebar
 * @constructor
 */
export function UseSidebar() {
  return useContext(SidebarContext);
}
